"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenType = exports.TokenTransferType = exports.transformTokenValidations = exports.MatchState = exports.WinOracle = exports.Match = void 0;
const anchor_1 = require("@project-serum/anchor");
class Match {
    constructor(key, data) {
        this.key = key;
        this.namespaces = data.namespaces;
        this.winOracle = data.winOracle;
        this.winOracleCooldown = data.winOracleCooldown;
        this.lastOracleCheck = data.lastOracleCheck;
        this.authority = data.authority;
        this.state = data.state;
        this.leaveAllowed = data.leaveAllowed;
        this.minimumAllowedEntryTime = data.minimumAllowedEntryTime;
        this.bump = data.bump;
        this.currentTokenTransferIndex = data.currentTokenTransferIndex;
        this.tokenTypesAdded = data.tokenTypesAdded;
        this.tokenTypesRemoved = data.tokenTypesRemoved;
        this.tokenEntryValidation = data.tokenEntryValidation;
        this.tokenEntryValidationRoot = data.tokenEntryValidationRoot;
        this.joinAllowedDuringStart = data.joinAllowedDuringStart;
    }
}
exports.Match = Match;
class WinOracle {
    constructor(key, data) {
        this.key = key;
        this.finalized = data.finalized;
        this.tokenTransferRoot = data.tokenTransferRoot;
        this.tokenTransfers = data.tokenTransfers;
    }
}
exports.WinOracle = WinOracle;
var MatchState;
(function (MatchState) {
    MatchState[MatchState["Draft"] = 0] = "Draft";
    MatchState[MatchState["Initialized"] = 1] = "Initialized";
    MatchState[MatchState["Started"] = 2] = "Started";
    MatchState[MatchState["Finalized"] = 3] = "Finalized";
    MatchState[MatchState["PaidOut"] = 4] = "PaidOut";
    MatchState[MatchState["Deactivated"] = 5] = "Deactivated";
})(MatchState = exports.MatchState || (exports.MatchState = {}));
function transformTokenValidations(args) {
    if (args.tokenEntryValidation) {
        args.tokenEntryValidation = args.tokenEntryValidation.map((r) => {
            const newRFilter = { ...r.filter };
            Object.keys(newRFilter).forEach((k) => {
                Object.keys(newRFilter[k]).forEach((y) => {
                    if (typeof newRFilter[k][y] === "string") {
                        newRFilter[k][y] = new anchor_1.web3.PublicKey(newRFilter[k][y]);
                    }
                });
            });
            r.filter = newRFilter;
            if (r.validation) {
                if (typeof r.validation.key === "string") {
                    r.validation.key = new anchor_1.web3.PublicKey(r.validation.key);
                    r.validation.code = new anchor_1.BN(r.validation.code);
                }
            }
            return r;
        });
    }
}
exports.transformTokenValidations = transformTokenValidations;
var TokenTransferType;
(function (TokenTransferType) {
    TokenTransferType[TokenTransferType["PlayerToPlayer"] = 0] = "PlayerToPlayer";
    TokenTransferType[TokenTransferType["PlayerToEntrant"] = 1] = "PlayerToEntrant";
    TokenTransferType[TokenTransferType["Normal"] = 2] = "Normal";
})(TokenTransferType = exports.TokenTransferType || (exports.TokenTransferType = {}));
var TokenType;
(function (TokenType) {
    TokenType[TokenType["Player"] = 0] = "Player";
    TokenType[TokenType["Item"] = 1] = "Item";
    TokenType[TokenType["Any"] = 2] = "Any";
})(TokenType = exports.TokenType || (exports.TokenType = {}));
